import { render, staticRenderFns } from "./ReviewsFraudAlert.vue?vue&type=template&id=0e7d2f72&"
import script from "./ReviewsFraudAlert.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewsFraudAlert.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7d2f72')) {
      api.createRecord('0e7d2f72', component.options)
    } else {
      api.reload('0e7d2f72', component.options)
    }
    module.hot.accept("./ReviewsFraudAlert.vue?vue&type=template&id=0e7d2f72&", function () {
      api.rerender('0e7d2f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsFraudAlert.vue"
export default component.exports